import PropTypes from 'prop-types'
import React, { Component } from 'react'

class BuyPricePromozione extends Component {
  render() {
    const valueClassName = this.props.valueClassName
      ? this.props.valueClassName
      : `${this.props.numberOrText} ${
          this.props.isFreePrice ? 'free-price' : ''
        }`

    const prezzoLogisticaStyled = (
      <React.Fragment>
        {this.props.promoLabel ? (
          <span className="main">{this.props.promoLabel}</span>
        ) : null}
        <span className="disabled" style={{ marginRight: '8px' }}>
          ({this.props.prezzoLogistica})
        </span>
      </React.Fragment>
    )

    const value = this.props.value
      ? this.props.value
      : this.props.prezzoLogistica

    const discount = (
      <span className={valueClassName}>
        {this.props.prezzoLogisticaPromozione ? (
          <React.Fragment>
            {prezzoLogisticaStyled}
            <span className="prezzo-logistica-promozione">
              {' '}
              {this.props.prezzoLogisticaPromozione}
            </span>
          </React.Fragment>
        ) : (
          <span className="prezzo-logistica-promozione main">{value}</span>
        )}
      </span>
    )

    return this.props.prezzoLogisticaPromozione !==
      this.props.prezzoLogistica ? (
      discount
    ) : (
      <span className={valueClassName}>
        <i></i>
        {this.props.prezzoLogisticaPromozione ? (
          <span>{this.props.prezzoLogisticaPromozione}</span>
        ) : (
          value
        )}
      </span>
    )
  }
}

BuyPricePromozione.defaultProps = {
  promoLabel: 'In promozione',
}

BuyPricePromozione.propTypes = {
  valueClassName: PropTypes.string,
  value: PropTypes.string,
  numberOrText: PropTypes.string,
  isFreePrice: PropTypes.bool,
  prezzoLogisticaPromozione: PropTypes.string,
  prezzoLogistica: PropTypes.string,
  promoLabel: PropTypes.string,
}

export default BuyPricePromozione
